import React, { forwardRef, useImperativeHandle } from 'react';

import * as General from '../General/General';
import * as rsuite from 'rsuite';
import { trackPromise } from 'react-promise-tracker';


const Auto_Ref = forwardRef((props, ref) => {

    const [List, setList] = React.useState([]);
    const [Type, setType] = React.useState(0);
    const on_Select = (event) => {
        props.onSelect(event)
    }

    const on_Change = (event) => {
        props.onChange(event)
    }
    useImperativeHandle(ref, () => ({

        Bind(type, title, date) {
            console.dir(type)
            setType(type);
            if (type == 0 || type == 4 || type == 7 || type == 6)
                setList([]);
            else if (type == 1) // SaleFactor
                setList([]);
            else if (type == 3) // ReturnFromBye
                trackPromise(
                    fetch(General.ApiRoute() + '/Product/SearchByGroup', {
                        method: 'Get',
                        headers: {
                            'ApiKey': General.APIKey(),
                            'Title': title
                        },
                        credentials: 'include'
                    })
                        .then(res => res.json())
                        .then(result => {
                            var tmp = []
                            for (var i = 0; i < result.length; i++) {
                                tmp.push({
                                    Row: i + 1,
                                    value: result[i].id + "|" + result[i].product + "|" + result[i].productId + "|" + result[i].count + "|" +
                                        result[i].returnCount + "|" + result[i].totalPrice + "|" + result[i].storeRoom + "|" + result[i].storeRoomId
                                        + "|" + result[i].headerCode + "|" + result[i].sriId,
                                    lable: "رسید : " + result[i].headerCode + " - محصول " + result[i].product + ' - انبار ' + result[i].storeRoom + " (" + result[i].count + " / " + result[i].returnCount + ")",

                                })
                            }
                            setList(tmp)
                        })
                )
            else if (type == 5) // ReturnTrust
                trackPromise(
                    fetch(General.ApiRoute() + '/StoreRoomRecipt/GetAsRef', {
                        method: 'Get',
                        headers: {
                            'ApiKey': General.APIKey(),
                            'Title': title
                        },
                        credentials: 'include'
                    })
                        .then(res => res.json())
                        .then(result => {
                            var tmp = []
                            for (var i = 0; i < result.length; i++) {
                                tmp.push({
                                    Row: i + 1,
                                    value: result[i].id + "|" + result[i].product + "|" + result[i].productId + "|" + result[i].count + "|" +
                                        result[i].returnCount + "|" + result[i].totalPrice + "|" + result[i].storeRoom + "|" + result[i].storeRoomId
                                        + "|" + result[i].headerCode + "|" + result[i].sriId + "|" + result[i].beforPhysicalCount + "|" + result[i].sriIdExist,
                                    lable: "رسید : " + result[i].headerCode + " - محصول " + result[i].product + ' - انبار ' + result[i].storeRoom + " (" + result[i].count + " / " + result[i].returnCount + ")",
                                    color: result[i].beforPhysicalCount == 0 || result[i].returnCount == result[i].count ? "red" : "",
                                })
                            }
                            setList(tmp)
                        })
                )
        },
    }),
        [props.value])

    return (
        <rsuite.AutoComplete
            data={List.map((product) => ({
                label: `${product.lable}`,
                value: `${product.value}`,
            }))}
            renderMenuItem={(item, index) => (
                <span style={{ color: item.color }}>{item.label}</span>
            )}
            value={props.value}
            label={props.lable}
            onChange={on_Change}
            onSelect={on_Select}
            placeholder='مبنا'
            disabled={Type == 0 ? true : false}
        />)
});

export default Auto_Ref;